import { Outlet, RouteObject, useParams } from "react-router-dom";

// --- Component Imports ---
import GeneralTimer from "../componentsCore/nav/GeneralTimer";
import ManufacturerContext from "../contexts/ManufacturerContext";

// --- Page Imports ---
import Categories from "../pages/Categories";
import Category from "../pages/Category";
import CompletedOrderDetails from "../pages/CompletedOrderDetails";
import CreateOpportunity from "../pages/CreateOpportunity";
import Document from "../pages/Document";
import DocumentError from "../pages/DocumentError";
import GeneralDocument from "../pages/GeneralDocument";
import Home from "../pages/Home";
import InsertProduct from "../pages/InsertProduct";
import Operations from "../pages/Operations";
import Opportunities from "../pages/Opportunities";
import Opportunity from "../pages/Opportunity";
import OrderDetails from "../pages/OrderDetails";
import P404 from "../pages/P404";
import Product from "../pages/Product";
import ProductError from "../pages/ProductError";
import Requisitions from "../pages/Requisitions";
import Reseller from "../pages/Reseller";
import ResellerError from "../pages/ResellerError";
import Resellers from "../pages/Resellers";
import Returns from "../pages/Returns";
import Search from "../pages/Search";
import SignInRedirect from "../pages/SignInRedirect";
import SiteMap from "../pages/SiteMap";
import WarehouseInformation from "../pages/WarehouseInformation";
import PartnerRelationshipPage from "../pages/PartnerRelationship";

import Path from "./Path";
import { ChatProvider } from "randmarcomps";
import BasicLayout from "../styles/BasicLayout";
import AuthProvider from "../providers/AuthProvider";
import Chat from "../pages/Chat";
import RouteError from "./RouteError";

function ManufacturerRoutesLayout() {
  const { applicationId = "" } = useParams();

  return (
    <ManufacturerContext.Provider value={{ applicationId }}>
      <GeneralTimer />
      <AuthProvider>
        <ChatProvider>
          <BasicLayout>
            <Outlet />
          </BasicLayout>
        </ChatProvider>
      </AuthProvider>
    </ManufacturerContext.Provider>
  );
}

export const routeConfig: RouteObject[] = [
  {
    path: "/signin-oidc",
    element: <SignInRedirect />,
    errorElement: <RouteError />,
  },
  {
    path: "/",
    element: <AuthProvider />,
    errorElement: <RouteError />,
  },
  {
    path: "/:applicationId",
    element: <ManufacturerRoutesLayout />,
    errorElement: <RouteError />,
    children: [
      { path: Path.home(), element: <Home /> },
      { path: Path.generalDocument(), element: <GeneralDocument /> },
      { path: Path.orderDetails(), element: <OrderDetails /> },
      { path: Path.completedOrderDetails(), element: <CompletedOrderDetails /> },
      { path: Path.requisitions(), element: <Requisitions /> },
      { path: Path.returns(), element: <Returns /> },
      { path: Path.categories(), element: <Categories /> },
      { path: Path.category(), element: <Category /> },
      { path: Path.product(), element: <Product />, errorElement: <ProductError /> },
      { path: Path.document(), element: <Document />, errorElement: <DocumentError /> },
      { path: Path.insertProduct(), element: <InsertProduct /> },
      { path: Path.sitemap(), element: <SiteMap /> },
      { path: Path.chat(), element: <Chat /> },
      { path: Path.reseller(), element: <Reseller />, errorElement: <ResellerError /> },
      { path: Path.resellers(), element: <Resellers /> },
      { path: Path.opportunities(), element: <Opportunities /> },
      { path: Path.createOpportunity(), element: <CreateOpportunity /> },
      { path: Path.opportunity(), element: <Opportunity /> },
      { path: Path.warehouseInformation(), element: <WarehouseInformation /> },
      { path: Path.operations(), element: <Operations /> },
      { path: Path.operationsSubSection(), element: <Operations /> },
      { path: Path.search(), element: <Search /> },
      { path: Path.partnerRelationship(), element: <PartnerRelationshipPage /> },
    ],
  },
  {
    path: "*", // Global catch-all for any undefined paths
    element: <P404 />,
    errorElement: <RouteError />,
  },
];
